/*
 * @Author: alex
 * @Date: 2023-05-24 22:39:30
 * @LastEditTime: 2023-05-30 19:40:28
 * @LastEditors: Alex yxfacw@163.com
 * @Description: 多地图同步效果
 */
import { MapBrowserEvent } from 'ol'
import { Coordinate } from 'ol/coordinate'
import Interaction from 'ol/interaction/Interaction'
import Map from 'ol/Map'
import { unByKey } from 'ol/Observable'
import Overlay from 'ol/Overlay'

const OVERLAY_ID = 'sync_target_overlay'

/**
 * 多个地图保持状态同步
 */
export default class Synchronize extends Interaction {
  /**
   * 需要同步的地图实例
   */
  private _maps: Map[]
  private _listener: any
  private _active = true
  constructor(options: { active?: boolean; maps?: Map[] }) {
    options = options || {}
    super({
      handleEvent: e => {
        if (e.type == 'pointermove') {
          this.handleMove(e)
        }
        return true
      }
    })

    this._maps = options.maps || []
    if (options.active === false) this.setActive(false)
  }

  /**
   * Remove the interaction from its current map, if any,  and attach it to a new
   * map, if any. Pass `null` to just remove the interaction from the current map.
   * @param {ol_Map} map Map.
   * @api stable
   */
  setMap(map: Map) {
    if (this._listener) {
      unByKey(this._listener.center)
      unByKey(this._listener.rotation)
      unByKey(this._listener.resolution)
      this.getMap()
        ?.getTargetElement()
        .removeEventListener('mouseout', evt => this._listener.mouseout)
    }
    this._listener = null

    super.setMap(map)

    if (map) {
      this._listener = {}
      this._listener.center = this.getMap()
        ?.getView()
        .on('change:center', evt => this.syncMaps())
      this._listener.rotation = this.getMap()
        ?.getView()
        .on('change:rotation', evt => this.syncMaps())
      this._listener.resolution = this.getMap()
        ?.getView()
        .on('change:resolution', evt => this.syncMaps())
      this._listener.mouseout = this.handleMouseOut
      if (this.getMap()?.getTargetElement()) {
        this.getMap()
          ?.getTargetElement()
          .addEventListener('mouseout', evt => this._listener.mouseout)
      }
      this.syncMaps()
    }
  }
  /** Auto activate/deactivate controls in the bar
   * @param {boolean} b activate/deactivate
   */
  setActive(b: boolean) {
    super.setActive(b)
    this._active = b
    this.syncMaps()
    if (!b) {
      // clear
      this._maps.forEach(map => {
        this.removeTarget(map)
      })
      const myMap = this.getMap()
      if (myMap) {
        this.removeTarget(myMap)
      }
    }
  }
  /**
   * Synchronize the maps
   */
  syncMaps() {
    if (!this._active) return
    const map = this.getMap()
    if (map) {
      if (map.get('lockView')) return
      for (let i = 0; i < this._maps.length; i++) {
        this._maps[i].set('lockView', true)
        // sync
        if (
          this._maps[i].getView().getRotation() != map.getView().getRotation()
        ) {
          this._maps[i].getView().setRotation(map.getView().getRotation())
        }
        if (this._maps[i].getView().getCenter() != map.getView().getCenter()) {
          this._maps[i].getView().setCenter(map.getView().getCenter())
        }
        if (
          this._maps[i].getView().getResolution() !=
          map.getView().getResolution()
        ) {
          this._maps[i].getView().setResolution(map.getView().getResolution())
        }
        this._maps[i].set('lockView', false)
      }
    }
  }
  /**
   * Cursor move > tells other maps to show the cursor
   * @param {ol.event} e "move" event
   */
  private handleMove(e: MapBrowserEvent<any>) {
    for (let i = 0; i < this._maps.length; i++) {
      this.showMapTarget(this._maps[i], e.coordinate)
    }
    const map = this.getMap()
    if (map) {
      this.showMapTarget(map)
    }
  }
  /**
   * Cursor out of map > tells other maps to hide the cursor
   * @param {event} e "mouseOut" event
   */
  private handleMouseOut(/*e*/) {
    for (let i = 0; i < this._maps.length; i++) {
      if (this._maps[i].getOverlayById(OVERLAY_ID)) {
        this._maps[i].getOverlayById(OVERLAY_ID).setPosition(undefined)
      }
    }
  }

  private showMapTarget(map: Map, coordinate?: Coordinate) {
    let overlay = map.getOverlayById(OVERLAY_ID)
    if (!overlay) {
      const elt = document.createElement('div')
      elt.classList.add('ol-target')
      overlay = new Overlay({ element: elt, id: OVERLAY_ID })
      overlay.setPositioning('center-center')
      map.addOverlay(overlay)
      elt.parentElement?.classList.add('ol-target-overlay')
      // hack to render targetOverlay before positioning it
      overlay.setPosition(map.getView().getCenter())
    }
    overlay.setPosition(coordinate)
  }

  private removeTarget(map: Map) {
    const overlay = map.getOverlayById(OVERLAY_ID)
    if (overlay) {
      map.removeOverlay(overlay)
      //   overlay = undefined
    }
  }
}
